import ProgressBar from '@avalara/bat-apps-shared/client/components/ProgressBar';
import { SCol, SContainer, SRow } from '@avalara/skylab-sdk/react';
import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router-dom';

import { setHeaderProductName } from '../../lib/aui-header';
import { checkIsAuthenticated } from '../../lib/helpers';
import { getLoginFromUrl, getMarketingDataFromUrl } from '../../lib/side-effects';
import { fetchAccountForReturns } from '../../lib/side-effects/accounts';
import { initializeReturnsProgressBar, stepNames } from '../../lib/side-effects/progress-bar';
import { selectState } from '../../selectors';
import { currentStepLabelSelector } from '../../selectors/progress-bar';
import { setActiveFlow } from '../../store/system';
import Company from '../offer/forms/company';
import GetStarted from '../offer/forms/get-started';
import { useAbandonedCart } from '../shared/hooks';
import LoginPrompt from '../shared/login-prompt';
import Accordion from './accordion';
import BuyButtonAndDisclaimer from './buy-button-and-disclaimer';
import OrderSummary from './order-summary';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import CybersourcePaymentPage from '../cybersource-payment';

const Returns = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const {
    account: { isLoggedIn },
    system: { activeFlow },
  } = useSelector(selectState);
  const currentStepLabel = useSelector(currentStepLabelSelector);

  useEffect(() => {
    dispatch(getMarketingDataFromUrl());
    dispatch(initializeReturnsProgressBar());
    setHeaderProductName('Managed Returns');
  }, []);

  // Note(Andrew) - We need this to happen before the other useEffect's, since otherwise
  //                the auth callback results in a 500 from the aui-identity module
  //                (not sure why currently)
  useState(getLoginFromUrl());
  useAbandonedCart();

  const onPaymentStep = currentStepLabel === stepNames.paymentMethod;

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    dispatch(setActiveFlow('returns'));

    if (isLoggedIn && !onPaymentStep) {
      history.push({ pathname: '/returns/payment', search: window.location.search });
    }
    // NOTE (Andrew) - we only need to check that they're not logged in (from account reducer) here
    //                 since we have a side effect in the app root that checks if they have an
    //                 active identity session and are not logged in (according to our account
    //                 reducer) and will fetch the account there, but we still want to force a
    //                 login for the returns flow here even if they are not authenticated
    //                 TODO: refactor/update the offer template to make this logic generic
    if (!isLoggedIn && !checkIsAuthenticated()) dispatch(fetchAccountForReturns('returns'));
  }, [isLoggedIn]);

  if (!isLoggedIn && !/net-new/.test(activeFlow || '')) return <LoginPrompt />;

  return (
    // biome-ignore lint/a11y/useSemanticElements: using Skylab's component
    <SContainer role='main'>
      <SRow>
        <SCol span='8' className='pad-top-sm'>
          {!isLoggedIn && <ProgressBar />}
        </SCol>
      </SRow>
      <SRow>
        <SCol span='8'>
          <Fragment>
            <Switch>
              <Route path='/returns/company'>
                <Company flow='returns' shouldFetchRegionsAndCountries={false} />
              </Route>
              <Route path='/returns/payment'>
                <CybersourcePaymentPage paymentView='offer' />
              </Route>
              <Route path='/'>
                <GetStarted flow='returns' />
              </Route>
            </Switch>
            <Accordion />
          </Fragment>
        </SCol>
        <SCol span='4'>
          <OrderSummary />
          {onPaymentStep && <BuyButtonAndDisclaimer />}
        </SCol>
      </SRow>
    </SContainer>
  );
};

export default Returns;
